module.exports = __webpack_public_path__ + "img/dangyuanzhiyuanzhe_icon.6fc1d595.png";